module.exports = __webpack_public_path__ + "img/other.5cc8f39.svg";